export const SET_LIST = "stores/SET_LIST";